var Moment = require('moment');
var MomentRange = require('moment-range');
var moment = MomentRange.extendMoment(Moment);
var utils = require('../../lib/utils');

module.exports = {
	config: {
		useShortWeekDays: false,
		environmentDependent: true
	},

	model: {
		// data is an array, always
		taskData: [],
		// prepared tasks grouped by day to render
		tasks: {},
		// current day selector
		today: moment().format('YYYYMMDD'),
		// initial view period is month if not defined different in config
		viewPeriod: "month",
		// start-date is today or overwritten from config
		startDate: false,
		// data for ejs header
		header: {
			title: "",
			colHeads: []
		},
		calendarDays: []
	},

	events: {
		baseControlButtons: {
			type: 'click',
			selector: '.nav button',
			action: function(event){

				var self = event.data.component;
				var $button, buttonAction;
				if (($button = $(event.target).closest('button')) && (buttonAction = $button.data('action'))){

					switch (buttonAction) {
						// show next view in current period
						case "next":
							if (self.model.viewPeriod === "month") {
								self.model.startDate = moment(self.model.startDate).add(1, 'months').date(1);
							} else if (self.model.viewPeriod === "week") {
								self.model.startDate = moment(self.model.startDate).startOf('week').add(1, 'weeks');
							} else {
								self.model.startDate = moment(self.model.startDate).add(1, 'days');
							}
							break;
						// show previous view in current period
						case "previous":
							if (self.model.viewPeriod === "month") {
								self.model.startDate = moment(self.model.startDate).subtract(1, 'months').date(1);
							} else if (self.model.viewPeriod === "week") {
								self.model.startDate = moment(self.model.startDate).startOf('week').subtract(1, 'weeks');
							} else {
								self.model.startDate = moment(self.model.startDate).subtract(1, 'days');
							}
							break;
						// change the period to day, week or month
						default:
							self.model.viewPeriod = buttonAction;
					}

					// viewMode-handler is available
					if (typeof self.onViewModeChanged === 'function') {
						self.onViewModeChanged(self.model.startDate, self.model.viewPeriod);
					} else {
						self.refresh();
					}
				}
			}
		},

		taskClickedHandler: {
			type: 'click',
			selector: '.base_scheduler_task',
			action: function(event){
				event.stopImmediatePropagation();
				var self = event.data.component;
				var $task, taskID, taskType;
				if (($task = $(event.target)) !== undefined && (taskType = $task.data('type')) !== undefined && (taskID = $task.data('id')) !== undefined){

					// task-handler is available
					if (typeof self.onTaskClicked === 'function') {
						self.onTaskClicked(taskType, taskID);
					} else {
						console.log("no task handler 'onTaskClicked()' available ...");
					}
				}
			}
		},

		dayClickedHandler: {
			type: 'click',
			selector: '.base_scheduler_wrapper > .day',
			action: function(event){
				var self = event.data.component;
				var $target, date;
				if (typeof self.onDayClicked === 'function') {
					if(($target = $(event.target).closest('.day')) && (date = $target.data('date'))){
						self.onDayClicked(date);
					} else {
						console.log("invalid conditions for day handler 'onDayClicked()'");
					}
				}
			}
		}
	},

	methods: {

		initConfigs: function(){
			// NOTE: OVERWRITE THIS IF NECCESSARY
		},

		onEnvironmentUpdated: function(){
			if(this.config.useShortWeekDays !== ((this.activeEnvironment || {}).style === 'mobile')){
				this.config.useShortWeekDays = (this.activeEnvironment || {}).style === 'mobile';
				this.refresh(false);
			}
		},

		setHeadColumnData: function(startDate) {

			if (typeof startDate === "undefined") startDate = false;

			var d, title;
			this.model.header.colHeads = [];
			// create column heads with day names
			for (d=1; d<=7; d++) {

				if(this.config.useShortWeekDays) 	title = String(moment.weekdaysShort(d)).replace(/\.$/, '');
				else 								title = moment.weekdays(d);

				// if a date is given, add it in the head
				if (startDate) {
					title += ", " + startDate.clone().add(d - 1, 'days').format('D.MMMM');
				}

				this.model.header.colHeads.push(title);
			}
		},

		buildMonthPeriod: function() {

			this.model.startDate = this.model.startDate.locale(this.config.locale || 'de')

			var dow;
			var firstMonthDay	= this.model.startDate.clone().startOf('month');
			var lastMonthDay	= this.model.startDate.clone().endOf('month');
			var firstDay		= firstMonthDay;
			var lastDay			= lastMonthDay;
			var month			= this.model.startDate.month();
			var lastMonth		= month - 1;
			if (lastMonth < 0)	lastMonth = 11;
			var nextMonth		= month + 1;
			if (nextMonth > 11)	nextMonth = 0;

			// set first day to monday before month
			dow = firstDay.isoWeekday();
			if (dow > 1) firstDay = moment(firstDay).subtract(dow - 1, 'days');
			// set last day as sunday after month
			dow = lastDay.isoWeekday();
			if (dow < 7) lastDay = moment(lastDay).add(7 - dow, 'days');

			var calMonthRange = moment.range(firstDay.toDate(), lastDay.toDate());
			var d;

			// set title
			this.model.header.title = firstMonthDay.format('MMMM YYYY');
			// set column heads with day names
			this.setHeadColumnData();

			this.model.calendarDays = [];

			var days = Array.from(calMonthRange.by('day'));
			var dayCnt = days.length;
			var curMonth, curDay, curWeek, lastWeek, curDaySelector, curDate;

			firstMonthDay = firstMonthDay.date();
			lastMonthDay  = lastMonthDay.date();
			for (d=0; d<dayCnt; d++) {

				// current indexes
				curMonth 		= days[d].month();
				curDay 			= days[d].date();
				curWeek 		= days[d].week();
				curDaySelector	= days[d].format('YYYYMMDD');
				curDate 		= days[d].format('YYYY-MM-DD');

				// append day-cell to list of days
				this.model.calendarDays.push({
					curDaySelector:	"d-" +curDaySelector,
					additionalCSS:	(curMonth !== month ? ' ext' : '') + (curDaySelector === this.model.today ? ' today' : ''),
					calendarWeek:	(curWeek !== lastWeek ? curWeek : false),
					title:			curDay + (curMonth !== month || curDay === firstMonthDay || curDay === lastMonthDay ? ". " + days[d].format('MMM').substr(0,3) : ''),
					date: 			curDate
				});

				// remember this week
				lastWeek = curWeek;
			}
		},

		buildWeekPeriod: function() {

			var firstWeekDay	= this.model.startDate.clone().startOf('week');
			var lastWeekDay		= this.model.startDate.clone().endOf('week');
			var week			= this.model.startDate.week();

			var calWeekRange = moment.range(firstWeekDay.toDate(), lastWeekDay.toDate());
			var d;

			// start date depending on different months
			var titleDateFrom =  (firstWeekDay.month() !== lastWeekDay.month() ? firstWeekDay.format('D. MMMM YYYY') : firstWeekDay.format('D.'));

			// set title
			this.model.header.title = '<div class="kw">KW ' + week + '</div>' + titleDateFrom + '<div class="seperator">-</div>' + lastWeekDay.format('D. MMMM YYYY');

			// set column heads with day names
			this.setHeadColumnData(firstWeekDay);

			var days = Array.from(calWeekRange.by('day'));
			var dayCnt = days.length;
			var curDaySelector;

			// container for days
			this.model.calendarDays = [];

			for (d=0; d<dayCnt; d++) {

				// current indexes
				curDaySelector	= days[d].format('YYYYMMDD');

				// append day-cell to list of days
				this.model.calendarDays.push({
					curDaySelector:	"d-" +curDaySelector,
					additionalCSS:	(curDaySelector === this.model.today ? ' today' : ''),
					calendarWeek:	false,
					title:			false
				});
			}
		},

		buildDayPeriod: function() {

			// empty col-heads, 'cause there are none
			this.model.header.colHeads = [];
			this.model.calendarDays = [];

			// set title
			this.model.header.title = moment.weekdays(this.model.startDate.day()) + ", " + this.model.startDate.format('D. MMMM YYYY');

			var curDaySelector	= this.model.startDate.format('YYYYMMDD');

			// append day-cell to list of days
			this.model.calendarDays.push({
				curDaySelector:	"d-" +curDaySelector,
				additionalCSS:	(curDaySelector === this.model.today ? ' today' : ''),
				calendarWeek:	false,
				title:			false
			});
		},


		sanitizeTasks: function(){

			var i, d, task, dataCnt = this.model.taskData.length, range, dateFrom, dateTo, taskClass, days, dayCnt;

			// empty task list
			this.model.tasks = {};

			// walk through tasks
			for (i=0; i<dataCnt; i++) {

				// clone object to prevent reference overwriting
				task = utils.simpleCopy(this.model.taskData[i]);

				// date period "from" is set
				if (task.dateFrom) {

					// date period "to" is not set -> a single day
					if (!task.dateTo) {
						// create a simple entry for the day
						task.date = task.dateFrom;
						this.prepareTask(task);
					}
					else {

						// build dates and a range of these dates
						dateFrom = moment(task.dateFrom);
						dateTo	 = moment(task.dateTo);
						range	 = moment.range(dateFrom.toDate(), dateTo.toDate());

						// get the days in this range as an array
						days = Array.from(range.by('day'));
						dayCnt = days.length;

						// only one day in range
						if (dayCnt === 1) {
							// create a simple entry for the day with hours from-to
							task.date = task.dateFrom;
							task.hourPeriod = true;
							this.prepareTask(task);

						} else { // multi day task

							// prepare class name
							taskClass = (task.class ? task.class : '');

							// walk through days in task
							for (d=0; d<dayCnt; d++) {

								task.isMultiMiddle = false;

								// set data depending on position in the task-period
								if (d===0) {
									task.date = dateFrom;
									task.class = taskClass + ' multi-start';
								}
								else if (d===dayCnt-1) {
									task.date = dateTo;
									task.class = taskClass + ' multi-end';
								}
								else {
									task.date = days[d];
									task.class = taskClass + ' multi-middle';
									task.isMultiMiddle = true;
								}

								// create and append the task
								this.prepareTask(task);
							}
						}
					}
				} else {
					// create and append the task
					this.prepareTask(task);
				}
			}
		},

		prepareTask: function(task) {

			// shorten call
			var m = moment(task.date);
			// get day cell
			var daySelector = 'd-' + m.format('YYYYMMDD');
			var title = '';

			// not the middel of a multi date entry
			if (task.isMultiMiddle !== true && task.showTime !== false) {
				// start time
				title += m.format('HH:mm');
				// end time if hour-period on the same day
				if (task.hourPeriod === true) {
					title += ' - ' + moment(task.dateTo).format('HH:mm');
				}
				// separator between hours and title
				title += ' | ';
			}
			// append title
			title += task.title;

			// prepare day collection of tasks
			if (typeof this.model.tasks[daySelector] === 'undefined') {
				this.model.tasks[daySelector] = [];
			}

			// append tasks
			this.model.tasks[daySelector].push({
				title:			title,
				additionalCSS:	(task.class		? ' ' + task.class : ''),
				id:				(task.dataID	? task.dataID : ''),
				type:			(task.dataType	? task.dataType : ''),
				alt:			(task.alt		? task.alt : '')
			});
		},

		onBeforeRender: function(){
			this.initConfigs();

			// locale 'de' or overwritten from config
			moment.locale(this.config.locale ? this.config.locale : 'de');

			// do not overwrite on refresh
			if (!this.model.viewPeriod && this.config.viewPeriod) {
				// initial view period is month if not defined different in config
				this.model.viewPeriod = this.config.viewPeriod;
			}

			// normalize view-period
			if (this.model.viewPeriod !== "month" && this.model.viewPeriod !== "week" && this.model.viewPeriod !== "day") {
				// initial period is month by default
				this.model.viewPeriod = "month";
			}

			// prepare startDate of calendar
			if (
				this.model.startDate &&
				(
					typeof this.model.startDate === 'string' ||
					typeof this.model.startDate === 'number' ||
					(
						typeof this.model.startDate === 'object' &&
						(
							moment.isDate(this.model.startDate) ||
							(
								moment.isMoment(this.model.startDate) &&
								typeof (this.model.startDate._d || {}).getTime === 'function'
							)
						)
					)
				)
			) {
				this.model.startDate = moment(this.model.startDate);
			} else if (this.config.startDate) {
				this.model.startDate = moment(this.config.startDate);
			} else {
				this.model.startDate = moment();
			}

			// depending on view-period (month or week)
			if (this.model.viewPeriod !== "day") {
				// the start-date must be modified to the first day of the given period
				this.model.startDate = this.model.startDate.startOf(this.model.viewPeriod);
			}

			// render view
			if (this.model.viewPeriod === "day") this.buildDayPeriod();
			else if (this.model.viewPeriod === "week") this.buildWeekPeriod();
			else this.buildMonthPeriod();

			// prepare tasks from given taskData
			this.sanitizeTasks();
		},

		onViewModeChanged: function(){
			// NOTE: this function may be overwritten if you want to know when the calender changes something.
		}
	}
};
